import { useEffect, useState } from "react";
import { providerPayoutBalnce } from "../../../config/LiveApi";
import { Close } from "@mui/icons-material";

const ProviderBalanceModal = ({ setShowModal }) => {
  const [providerData, setProviderData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await providerPayoutBalnce();
      console.log("Provider Balance Response:", response);
      setProviderData(response || []);
    } catch (err) {
      console.error("Error fetching provider balance rate:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div className="overlay-provider-success">
      <div className="modal-provider-success">
        <div className="modal-header-provider-success">
          <h3 className="title-provider-success">📊 ₹ Provider Balance</h3>
          <Close
            onClick={() => setShowModal(false)}
            className="close-btn-provider-success"
          />
        </div>

        <div className="table-wrapper-provider-success">
          <table className="table-provider-success">
            <thead>
              <tr>
                <th>S.No</th>
                <th>OrgName</th>
                <th>Provider Name</th>
                <th>Balance(₹)</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="4" className="no-data-provider-success">
                    Loading...
                  </td>
                </tr>
              ) : providerData && providerData.length > 0 ? (
                providerData.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.organization || "N/A"}</td>
                    <td>{item.provider || "N/A"}</td>
                    <td>
                      <span className="blanceText">
                        {item.balance || "N/A"}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="no-data-provider-success">
                    No Provider data available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* <div className="buttons-provider-success">
          <button
            type="button"
            onClick={() => setShowModal(false)}
            className="close-btn-provider-success"
          >
            Close
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default ProviderBalanceModal;
